module.exports = __webpack_public_path__ + "img/visu-fauche-flora@2x.ebdd5c90.jpg";